var m = require('mithril');
var prop = require('mithril/stream');
var dragscroll = require('../../libs/dragscroll');
var auth = require('../../auth/models/session');
var loaders = require('../../layout/components/loaders');
var edit = require('../../layout/components/edit');
var modal = require('../../layout/components/modal');
var header = require('../../layout/components/header');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var rowActionDropdown = require('../../components/rowActionDropdown');
var networkTreeTransferModal = require('../treeTransferModal');
var agentGatewayStatusStore = require('../agentGatewayStatusStore');
var tableColumns = require('./tableColumns');
var requestState = require('../requestState');

var page = {};

function isEnabled(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function canEditHosts() {
  return edit.vm.editing() && auth.user().isSuperuser == 1;
}

function renderFieldValue(field, record, url, ctrl) {
  if (field === 'name') return renderNameCell(record, url, ctrl);
  if (field === 'status') return renderAgentStatus(record);
  if (field === 'enabled') {
    return enabledBoolBox(
      record[field],
      record.name || 'Host',
      canEditHosts() ? function () { ctrl.form.editDialogue(record); } : null
    );
  }
  return record[field];
}

function renderAgentStatus(record) {
  var status = agentGatewayStatusStore.statusForRecord(record);
  return m('span.' + agentGatewayStatusStore.statusClass(status), status);
}

function enabledBoolBox(value, label, onclick) {
  var enabled = isEnabled(value);
  var clickable = typeof onclick === 'function';
  var classes = 'h1.w1.ba.b--blue' + (enabled ? '.bg-blue' : '');
  var tag = clickable ? 'button.bn.bg-transparent.pa0.dib' : 'span.dib';
  var attrs = clickable
    ? {
        type: 'button',
        onclick: onclick,
        title: 'Edit ' + label,
        'aria-label': 'Edit ' + label + ' enabled setting',
        style: { cursor: 'pointer' }
      }
    : {
        role: 'img',
        title: enabled ? 'Enabled' : 'Disabled',
        'aria-label': label + (enabled ? ' enabled' : ' disabled')
      };
  return m(tag, attrs, [
    m('div.' + classes, {
      style: { backgroundClip: 'content-box', padding: '2px' }
    })
  ]);
}

function renderNameCell(record, url, ctrl) {
  return m('div.flex.items-center.justify-between', [
    m(m.route.Link, {href: url}, record.name),
    m('div.ml3.flex-none', [
      actionDropdown([
        {
          label: 'Edit Host',
          icon: 'ion-ios-compose',
          onclick: function () { ctrl.form.editDialogue(record); }
        },
        {
          label: 'Delete Host',
          icon: 'ion-ios-trash',
          class: 'red',
          onclick: function () { ctrl.form.deleteDialogue(record); }
        }
      ])
    ])
  ]);
}

function actionDropdown(items) {
  return m(rowActionDropdown, {
    position: 'fixed',
    align: 'left',
    buttonStyle: {
      minWidth: '1.6rem',
      paddingTop: '0.05rem',
      paddingBottom: '0.12rem',
      paddingLeft: '0.18rem',
      paddingRight: '0.18rem',
      lineHeight: '1'
    },
    items: items
  });
}

page.oninit = function (vnode) {
  var ctrl = this;
  ctrl.form = vnode.attrs.form;
  document.title = 'nimrod | ' + ctrl.form.name;
  ctrl.newNode = prop(false);
  requestState.initialize(ctrl);
  
  header.vm.activeTab(vnode.attrs.activeTab);

  ctrl.init = function () {
    return requestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        url: "/api/v1/" + ctrl.form.url,
        method: "GET",
      })
      .then(function (res) {
        ctrl.hosts = res;
        ctrl.sort();
        ctrl.newNode(true);
      });
    });
  };


  ctrl.sort = function () {
    ctrl.hosts.sort(sortByStatus);
  };

  modal.on('closed', ctrl.init);
  
  ctrl.childrenToShow = [];
  ctrl.handleAgentStatusUpdate = function () {
    if (ctrl.hosts) ctrl.sort();
    m.redraw();
  };
  ctrl.unsubscribeAgentStatus = agentGatewayStatusStore.subscribe(ctrl.handleAgentStatusUpdate);
  ctrl.init();
};

page.onremove = function (vnode) {
  modal.off('closed', this.init);
  if (this.unsubscribeAgentStatus) this.unsubscribeAgentStatus();
};

page.view = function () {
  var ctrl= this
  var stateView = requestState.view(ctrl);
  if (stateView) return stateView;
  if(!ctrl.hosts){
    return m('div')
  }
  var isTreeTransferOverview = ctrl.form && ['BacnetServer', 'ModbusTcp', 'RestHttp', 'LontalkCnip'].indexOf(ctrl.form['@class']) >= 0;
  var networkOverviewName = ctrl.form['@class'] === 'BacnetServer'
    ? 'BACnet Host'
    : ctrl.form['@class'].replace(/([A-Z])/g, ' $1');
  return m('div', [
    m("div.mh3.mb3.pb2.bb.bw1.b--mid-gray.near-white.flex.justify-between.items-center.display",  [
      m('div.pb2.f-subheadline.fw5', [
        m('div.dib-ns.mr2', [
          m(m.route.Link, {href: '/networks'}, 'Networks'),
          ' / '
        ]),
        m('div.dib-ns.mr2', networkOverviewName),
      ]),
      canEditHosts() ? m(rowActionDropdown, {
        items: [
          {
            label: 'New ' + ctrl.form.name,
            icon: 'ion-plus',
            onclick: () => ctrl.form.editDialogue({})
          },
          isTreeTransferOverview ? {
            label: 'Import Network Trees',
            icon: 'ion-upload',
            onclick: () => networkTreeTransferModal.openNetworkImportModal(ctrl.init)
          } : null,
          isTreeTransferOverview ? {
            label: 'Export Network Trees',
            icon: 'ion-document-text',
            onclick: () => networkTreeTransferModal.openNetworkExportModal(ctrl.hosts)
          } : null
        ].filter(Boolean)
      }) : ''
    ]),
    m('div.cf', browse(ctrl)),
  ])
};

function browse (ctrl) {
  var fieldsArray = visibleFieldKeys(ctrl.form.fields);
  return m('div.mh3',[
    m(paginationWithSearch, {
      data: ctrl.hosts,
      newNode: ctrl.newNode,
      dataToShow: ctrl.childrenToShow,
      placeHolder: 'Search',
      itemsPerPage: 30,
      fieldsToSearch: ['name', 'host', '@class']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', [
              tableColumns.colgroup(fieldsArray),
              m('thead', [
                m('tr', [ 
                  fieldsArray.map(field => {
                    return m('th.ph0.tl', field)
                  })
                ])
                
              ]),
              m('tbody', [
                ctrl.childrenToShow.map(children => {
                  if(!children['@rid']){
                    return m('tr', [
                      fieldsArray.map(field => {
                        return m('td.tl.nowrap',[
                          m('label',{style:{'visibility':'hidden'}}, 'No Data')  
                        ])
                      })
                    ])
                  }else{
                    let url = '/' + children['@id'].split('/').slice(3,5).join('/').toLowerCase();
                    return m('tr', [
                      fieldsArray.map(field => {
                        return m('td.tl'+(field != 'error' ? '.nowrap' : ''), renderFieldValue(field, children, url, ctrl))
                      })
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
      
    ])
  ])
};

function visibleFieldKeys(fields) {
  return Object.keys(fields || {}).filter(function (field) {
    var fieldDef = fields[field] || {};
    return !fieldDef.hidden && field !== 'username' && field !== 'password';
  });
}


function sortByStatus (a,b) {
  var aStatusRank = agentGatewayStatusStore.statusRank(agentGatewayStatusStore.statusForRecord(a));
  var bStatusRank = agentGatewayStatusStore.statusRank(agentGatewayStatusStore.statusForRecord(b));

  if (aStatusRank < bStatusRank) {
    return 1;
  } else if (aStatusRank > bStatusRank) {
    return -1;
  } else {
    return 0;
  }
};

module.exports = page;
